<div class="content-wrapper">
    <div class="container-xxl flex-grow-1 container-p-y">
      <mat-drawer-container>
        <mat-drawer [mode]="(screenWidth > 800) ? 'side' : 'over'" [opened]="sideBarOpen" class="aside">
          <!-- <app-side-nav></app-side-nav> -->
          <app-vendor-side-nav></app-vendor-side-nav>
        </mat-drawer>
  
        <mat-drawer-content>
          <app-vendor-header (toggleSidebarForMe)="sideBarToggler()"></app-vendor-header>
          <router-outlet></router-outlet>
          <app-footer class="footer"></app-footer>
        </mat-drawer-content>
      </mat-drawer-container>
    </div>
  </div>